import * as Types from '../types'

export const clearCurrentCartExpirationMessage = () => {
    return dispatch => {
        dispatch({ type: Types.CLEAR_CURRENT_CART_EXPIRATION_MESSAGE })
    }
}
